import React from "react";
import { Link } from "react-router-dom";

export function About() {
  const values = [
    {
      title: "Client-Centric Excellence",
      desc: "Every architecture and line of code is structured to deliver immediate value and long-term business ROI."
    },
    {
      title: "Continuous Innovation",
      desc: "Leveraging cutting-edge cloud architectures, automated workflows, and modern software paradigms."
    },
    {
      title: "Integrity & Transparency",
      desc: "Open communication, honest timelines, and collaborative technical partnerships with all stakeholders."
    },
    {
      title: "Human Capital Empowerment",
      desc: "Maximizing the potential of clients, candidates, and engineering teams through continuous learning."
    }
  ];

  return (
    <div className="about-page">
      <div className="page-banner">
        <div className="container">
          <span className="badge">Who We Are</span>
          <h1>About Advanced Cloudlink Technologies</h1>
          <p>
            A forward-thinking IT consulting firm dedicated to transforming complex challenges into seamless digital solutions.
          </p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <span className="section-tag">Our Story & Mission</span>
              <h2>Delivering Transformative Results Through Technology</h2>
              <p>
                Advanced Cloudlink Technologies Inc is a premier global IT services and consulting firm.
                We specialize in architecting high-quality, client-centric solutions with deep domain expertise
                across cloud infrastructure, custom application engineering, and enterprise process automation.
              </p>
              <p>
                We also offer customized web and mobile solutions tailored for complex, time-critical business
                environments. Our ongoing investment in automated solutions and proprietary product accelerators
                enables our clients to minimize manual overhead, reduce operational risk, and scale efficiently.
              </p>
              <p>
                By transforming data into actionable intelligence, ACT helps organizations achieve new standards of
                operational excellence while maximizing the collective potential of clients, candidates, and engineering talent.
              </p>
            </div>

            <div className="values-grid">
              {values.map((v, i) => (
                <div key={i} className="value-card">
                  <h4>{v.title}</h4>
                  <p>{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="section" style={{ backgroundColor: "#ffffff", borderTop: "1px solid #e2e8f0" }}>
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Our Vision</span>
            <h2 className="section-title">The Foundation of Our Consulting Practice</h2>
            <p className="section-desc">
              We bridge the gap between complex enterprise goals and modern technical execution.
            </p>
          </div>

          <div className="cards-grid">
            <div className="service-card">
              <div className="service-icon-box">🎯</div>
              <h3 className="service-title">Our Mission</h3>
              <p className="service-text">
                To empower enterprises with agile, secure, and scalable cloud architectures, web solutions, and automated workflows that eliminate friction and unlock growth.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon-box">🌐</div>
              <h3 className="service-title">Global Perspective</h3>
              <p className="service-text">
                Operating with enterprise rigor from Texas, USA, while leveraging a global network of specialized engineering talent to deliver 24/7 velocity.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon-box">🏆</div>
              <h3 className="service-title">Quality Assurance</h3>
              <p className="service-text">
                We adhere strictly to enterprise coding standards, automated testing frameworks, and cloud security benchmarks on every engagement.
              </p>
            </div>
          </div>

          <div className="cta-banner">
            <h2>Looking for an agile technology partner?</h2>
            <p>
              Let us help you design, build, and optimize your next digital initiative.
            </p>
            <Link to="/contact" className="btn-white">
              Connect With Us →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
